import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import Stepper from "@material-ui/core/Stepper";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import React from "react";
import "./index.css";
import If from "../Common/If";

const styles = (theme) => ({
  root: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
  },
  contentRoot: {
    marginTop: 16,
    borderLeft: "0px solid #bdbdbd",
    marginLeft: 0,
    paddingLeft: 0,
    paddingRight: 8,
  },
  backButton: {
    marginRight: theme.spacing.unit,
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
});

class VerticalStepperComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      completed: props.completed || {},
      AllStep: props.AllStep || [],
    };

    this.handleStep = this.handleStep.bind(this);
  }

  componentWillReceiveProps(props) {
    // if (props.AllStep != this.state.AllStep) {
      this.setState({ AllStep: props.AllStep });
    // }
    this.setState({ completed: props.completed || this.state.completed, activeStep: props.activeStep });
  }

  componentDidMount() {
    this.props.onRef(this);
  }

  handleNext = () => {
    let activeStep;
    const { completed } = this.state;
    if (this.isLastStep() && !this.allStepsCompleted()) {
      activeStep = this.state.AllStep.findIndex((step, i) => !(i in this.state.completed));
      completed[activeStep] = true;
    } else {
      completed[this.state.activeStep] = true;
      activeStep = this.state.activeStep + 1;
    }
    this.setState({ completed, activeStep }, () => {
      this.props.setStep(activeStep, completed);
    });
  };

  handleBack = () => {
    this.setState((state) => ({
      activeStep: state.activeStep - 1,
    }));
  };

  handleReset = () => {
    this.setState({
      activeStep: 0,
      completed: {},
    });
  };

  handleStep(step) {
    this.setState(
        {
          activeStep: step,
        },
        () => {
          this.props.setStep(step, this.state.completed);
        },
    );
    // if (!this.state.completed[step]) {
    //   return false;
    // }
    // this.setState(
    //   {
    //     activeStep: step,
    //   },
    //   () => {
    //     this.props.setStep(this.state.activeStep, this.state.completed);
    //   },
    // );
  }

  totalSteps = () => this.state.AllStep.length;

  completedSteps() {
    return Object.keys(this.state.completed).length;
  }

  isLastStep() {
    return this.state.activeStep === this.totalSteps() - 1;
  }

  allStepsCompleted() {
    return this.completedSteps() === this.totalSteps();
  }

  // isStepFailed = step => this.state.FailedSteps.includes(step);

  getStepIcon = (index) => {
    const { activeStep, completed } = this.state;
    return (
      <span className="t-13">
        <If condition={activeStep == index}>
          <span className="current-step text-color-blue">{index + 1}</span>
        </If>
        <If condition={activeStep != index && completed[index]}>
          <span className="completed-step">{index + 1}</span>
        </If>
        <If condition={!(activeStep == index || completed[index])}>
          <span className="disabled-step">{index + 1}</span>
        </If>
      </span>
    );
  };

  getStepLabel = (index, label) => {
    const { activeStep, completed } = this.state;
    return (
      <span>
        <If condition={activeStep == index}>
          <span className="active-step-label">{label}</span>
        </If>
        <If condition={activeStep != index && completed[index]}>
          <span className="inactive-step-label">{label}</span>
        </If>
        <If condition={!(activeStep == index || completed[index])}>
          <span className="inactive-step-label">{label}</span>
        </If>
      </span>
    );
  };

  render() {
    const { classes } = this.props;
    const { AllStep = [], activeStep, completed } = this.state;
    // const ActiveComp = get(AllStep, `[${activeStep}].component`, <div></div>);

    return (
      <div>
        <Stepper
          className={classes.root}
          activeStep={activeStep}
          nonLinear
          alternativeLabel={false}
          orientation="vertical"
        >
          {AllStep && AllStep.map((step, index) => {
            const props = {};
            const labelProps = {};
            return (
              <Step
                className={classNames(
                  index == this.state.activeStep
                    ? "ActiveStep  active-vertical-step vertical-step-wrapper"
                    : "inactive-vertical-step vertical-step-wrapper",
                )}
                key={index + 1}
                {...props}
              >
                <StepButton
                  // disabled={!completed[index]}
                  onClick={() => this.handleStep(index)}
                  icon={this.getStepIcon(index)}
                  completed={completed[index]}
                >
                  <StepLabel {...labelProps} className="stepper-tab">
                    {/* {step.label} */}
                    {this.getStepLabel(index, step.label)}
                  </StepLabel>
                </StepButton>
                <StepContent className={classes.contentRoot}>
                  <div>
                    {// activeStep === AllStep.length ? null : (
                      <div>{AllStep && AllStep[activeStep] && AllStep[activeStep].component}</div>
                    // )
                    }
                  </div>
                </StepContent>
              </Step>
            );
          })}
        </Stepper>
      </div>
    );
  }
}

export default withStyles(styles)(VerticalStepperComponent);
